import React, { useState } from 'react';
type MenuItem = {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
};
const menuItems: MenuItem[] = [{
  title: 'Home',
  url: '/'
}, {
  title: 'Activities',
  url: '/Activities.html',
  children: [{
    title: 'Sporting Clays',
    url: '/SportingClays.html'
  }, {
    title: 'Sporting Clays Scores & Events',
    url: '/SportingClaysScoresEvents.html'
  }, {
    title: 'Cowboy Action Shooting',
    url: '/SASS.html'
  }, {
    title: 'Steel Challenge',
    url: '/SteelChallenge.html'
  }, {
    title: '3-D Archery',
    url: '/3DArchery.html'
  }, {
    title: 'Jr. Rifle',
    url: '/JrRifle.htm'
  }, {
    title: 'PPC Shooting',
    url: '/PPCShooting.html'
  }, {
    title: 'Bowling Pin Shoots',
    url: '/BowlingPinShoots.html'
  }]
}, {
  title: 'Firearms Education',
  url: '',
  children: [{
    title: 'Self Defense Class',
    url: '/FLSCSelfDefense.html'
  }, {
    title: 'Refuse To Be A Victim',
    url: '/RefuseToBeAVictim.html'
  }, {
    title: 'NRA Range Safety Officer',
    url: '/NRARangeSafetyOfficer.html'
  }, {
    title: 'NRA First Steps Pistol',
    url: '/NRAFirstStepsPistol.html'
  }, {
    title: 'CPL Course',
    url: '/NRAPersonalProtectionInTheHome.html'
  }, {
    title: 'CPL Renewal',
    url: '/MICPLRenewalClass.html'
  }, {
    title: 'Personal Protection',
    url: '/NRAPersonalProtectionOutsideTheHome.html'
  }, {
    title: 'CRASE',
    url: '/CRASE.html'
  }]
}, {
  title: 'Club Info',
  url: '',
  children: [{
    title: 'Calendar',
    url: '/Calendar.html'
  }, {
    title: 'Clubhouse Rental',
    url: '/ClubhouseRental.html'
  }, {
    title: 'Newsletter',
    url: '/FLSCNewsletter.html'
  }, {
    title: 'Range Rules',
    url: '/RangeRules.html'
  }, {
    title: 'Photo Tour',
    url: '/PhotoTour.html'
  }, {
    title: 'Privacy Policy',
    url: '/PrivacyPolicy.html'
  }]
}, {
  title: 'Contact Us',
  url: '/ContactUs.html',
  children: [{
    title: 'Constitution & By-Laws',
    url: '/ConstitutionAndByLaws.html'
  }, {
    title: 'Policies & Procedures',
    url: '/PoliciesAndProcedures.html'
  }, {
    title: 'Election',
    url: '/FLSCElection2026.html'
  }]
}, {
  title: 'STORE',
  url: 'https://my-store-c0b81b.creator-spring.com'
}];
export function DesktopNav() {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const pathname = window.location.pathname;
  const checkActive = (path: string): boolean => {
    return path === '/' ? pathname.substr(-1) === '/' : pathname.indexOf(path) !== -1;
  };
  return <nav className="hidden lg:flex items-center gap-0" aria-label="Main navigation" data-id="element-116">
      {menuItems.map(item => {
      const isActive = item.url ? checkActive(item.url) : item.children?.some(child => checkActive(child.url)) ?? false;
      const isStore = item.title === 'STORE';
      const chevronDown = <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-117">
            <path d="m6 9 6 6 6-6" data-id="element-118" />
          </svg>;
      return <div key={item.title} className="nav-item relative group" data-id="element-119">
            {item.children ? item.url ? <a href={item.url} className="flex items-center gap-0.5 px-2.5 py-2 font-medium rounded transition-colors" style={{
          color: isActive ? '#c8a84b' : '#e8e4d8',
          fontFamily: 'Inter, sans-serif',
          fontSize: '15px'
        }} onMouseEnter={() => setOpenDropdown(item.title)} onMouseLeave={() => setOpenDropdown(null)} aria-haspopup="true" aria-expanded={openDropdown === item.title} data-id="element-120">
                  {item.title}
                  {chevronDown}
                </a> : <button className="flex items-center gap-0.5 px-2.5 py-2 font-medium rounded transition-colors" style={{
          color: isActive ? '#c8a84b' : '#e8e4d8',
          fontFamily: 'Inter, sans-serif',
          fontSize: '15px'
        }} onMouseEnter={() => setOpenDropdown(item.title)} onMouseLeave={() => setOpenDropdown(null)} aria-haspopup="true" aria-expanded={openDropdown === item.title} data-id="element-121">
                  {item.title}
                  {chevronDown}
                </button> : isStore ? <a href={item.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 px-3 py-1.5 mx-1 rounded font-semibold transition-all hover:opacity-90" style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '13px',
          color: '#1a1a1a',
          backgroundColor: '#c8a84b',
          letterSpacing: '0.04em',
          textTransform: 'uppercase'
        }} data-id="element-122">
                {/* ShoppingBag icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-123">
                  <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" data-id="element-124" />
                  <path d="M3 6h18" data-id="element-125" />
                  <path d="M16 10a4 4 0 0 1-8 0" data-id="element-126" />
                </svg>
                {item.title}
              </a> : <a href={item.url || '/'} className="block px-2.5 py-2 font-medium rounded transition-colors relative" style={{
          color: isActive ? '#c8a84b' : '#e8e4d8',
          fontFamily: 'Inter, sans-serif',
          fontSize: '15px'
        }} data-id="element-127">
                {item.title}
                {isActive && <span className="absolute bottom-0 left-2.5 right-2.5 h-0.5 rounded-full" style={{
            backgroundColor: '#c8a84b'
          }} data-id="element-128" />}
              </a>}
            {item.children && <div className="nav-dropdown" onMouseEnter={() => setOpenDropdown(item.title)} onMouseLeave={() => setOpenDropdown(null)} data-id="element-129">
                {item.children.map(sub => <a key={sub.url} href={sub.url} data-id="element-130">
                    {sub.title}
                  </a>)}
              </div>}
          </div>;
    })}
    </nav>;
}